import Vue from 'vue'
import vuex from 'vuex'
import base from './base'
import imgUrl from './imgUrl'

Vue.use(vuex)
export default new vuex.Store({
  modules: {
    base,
    imgUrl
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js